// Author YuJiaBei
// Date 2021-12-15 15:27:48

class RepairPlanDetail {
constructor({
        id = null,
        rpdIdRpl = '',
        rpdIdPlan = '',
        rpdIdBusiness = '',
        rpdCodePdr = '',
        rpdTypeCode = '',
        rpdType = '',
        rpdCodeBusiness = '',
        rpdStatusBusiness = '',
        rpdResponsible = '',
        rpdDurationPlan = '',
        rpdDurationActual = '',
        rpdBeginTimeForcast = '',
        rpdBeginTimeActual = '',
        rpdEndTimeForcast = '',
        rpdEndTimeActual = '',
        rpdSpareCostPlan = '',
        rpdSpareCostActual = '',
        rpdLaborCostPlan = '',
        rpdLaborCostActual = '',
        rpdTotalCostPlan = '',
        rpdTotalCostActual = '',
        rpdRemark = ''}
= {}) {
    this.id = id;
    this.rpdIdRpl = rpdIdRpl;
    this.rpdIdPlan = rpdIdPlan;
    this.rpdIdBusiness = rpdIdBusiness;
    this.rpdCodePdr = rpdCodePdr;
    this.rpdTypeCode = rpdTypeCode;
    this.rpdType = rpdType;
    this.rpdCodeBusiness = rpdCodeBusiness;
    this.rpdStatusBusiness = rpdStatusBusiness;
    this.rpdResponsible = rpdResponsible;
    this.rpdDurationPlan = rpdDurationPlan;
    this.rpdDurationActual = rpdDurationActual;
    this.rpdBeginTimeForcast = rpdBeginTimeForcast;
    this.rpdBeginTimeActual = rpdBeginTimeActual;
    this.rpdEndTimeForcast = rpdEndTimeForcast;
    this.rpdEndTimeActual = rpdEndTimeActual;
    this.rpdSpareCostPlan = rpdSpareCostPlan;
    this.rpdSpareCostActual = rpdSpareCostActual;
    this.rpdLaborCostPlan = rpdLaborCostPlan;
    this.rpdLaborCostActual = rpdLaborCostActual;
    this.rpdTotalCostPlan = rpdTotalCostPlan;
    this.rpdTotalCostActual = rpdTotalCostActual;
    this.rpdRemark = rpdRemark;
}
}

function newEntity() {
return new RepairPlanDetail();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'rpdType',
        label: 'label.em.repair.repairPlanDetail.grid.rpdType',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'rpdCodeBusiness',
        label: 'label.em.repair.repairPlanDetail.grid.rpdCodeBusiness',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'rpdStatusBusiness',
        label: 'label.em.repair.repairPlanDetail.grid.rpdStatusBusiness',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'statusName',
        label: 'label.em.repair.repairPlanDetail.grid.statusName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'rpdResponsible',
        label: 'label.em.repair.repairPlanDetail.grid.rpdResponsible',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'rpdBeginTimeForcast',
        label: 'label.em.repair.repairPlanDetail.grid.rpdBeginTimeForcast',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'rpdBeginTimeActual',
        label: 'label.em.repair.repairPlanDetail.grid.rpdBeginTimeActual',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'rpdEndTimeForcast',
        label: 'label.em.repair.repairPlanDetail.grid.rpdEndTimeForcast',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'rpdEndTimeActual',
        label: 'label.em.repair.repairPlanDetail.grid.rpdEndTimeActual',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'rpdRemark',
        label: 'label.em.repair.repairPlanDetail.grid.rpdRemark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    rpdIdRplFilter : '',
    rpdCodeBusinessFilter : '',
    rpdStatusBusinessFilter : '',
    rpdResponsibleFilter : '',
    rpdBeginTimeForcastRteFilter : '',
    rpdBeginTimeForcastLteFilter : '',
    rpdBeginTimeActualRteFilter : '',
    rpdBeginTimeActualLteFilter : '',
    rpdEndTimeForcastRteFilter : '',
    rpdEndTimeForcastLteFilter : '',
    rpdEndTimeActualRteFilter : '',
    rpdEndTimeActualLteFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'rpdCodeBusinessFilter',
        label: 'label.em.repair.repairPlanDetail.filter.rpdCodeBusiness',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'rpdStatusBusinessFilter',
        label: 'label.em.repair.repairPlanDetail.filter.rpdStatusBusiness',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'rpdResponsibleFilter',
        label: 'label.em.repair.repairPlanDetail.filter.rpdResponsible',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'rpdBeginTimeForcastRteFilter',
        label: 'label.em.repair.repairPlanDetail.filter.rpdBeginTimeForcastRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'rpdBeginTimeForcastLteFilter',
        label: 'label.em.repair.repairPlanDetail.filter.rpdBeginTimeForcastLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'rpdBeginTimeActualRteFilter',
        label: 'label.em.repair.repairPlanDetail.filter.rpdBeginTimeActualRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'rpdBeginTimeActualLteFilter',
        label: 'label.em.repair.repairPlanDetail.filter.rpdBeginTimeActualLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'rpdEndTimeForcastRteFilter',
        label: 'label.em.repair.repairPlanDetail.filter.rpdEndTimeForcastRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'rpdEndTimeForcastLteFilter',
        label: 'label.em.repair.repairPlanDetail.filter.rpdEndTimeForcastLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'rpdEndTimeActualRteFilter',
        label: 'label.em.repair.repairPlanDetail.filter.rpdEndTimeActualRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'rpdEndTimeActualLteFilter',
        label: 'label.em.repair.repairPlanDetail.filter.rpdEndTimeActualLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'rpdIdRpl',
        label: 'label.em.repair.repairPlanDetail.entity.rpdIdRpl',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rpdIdPlan',
        label: 'label.em.repair.repairPlanDetail.entity.rpdIdPlan',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rpdIdBusiness',
        label: 'label.em.repair.repairPlanDetail.entity.rpdIdBusiness',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rpdCodePdr',
        label: 'label.em.repair.repairPlanDetail.entity.rpdCodePdr',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'rpdTypeCode',
        label: 'label.em.repair.repairPlanDetail.entity.rpdTypeCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'rpdType',
        label: 'label.em.repair.repairPlanDetail.entity.rpdType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'rpdCodeBusiness',
        label: 'label.em.repair.repairPlanDetail.entity.rpdCodeBusiness',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'rpdStatusBusiness',
        label: 'label.em.repair.repairPlanDetail.entity.rpdStatusBusiness',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'rpdResponsible',
        label: 'label.em.repair.repairPlanDetail.entity.rpdResponsible',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'rpdDurationPlan',
        label: 'label.em.repair.repairPlanDetail.entity.rpdDurationPlan',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rpdDurationActual',
        label: 'label.em.repair.repairPlanDetail.entity.rpdDurationActual',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rpdBeginTimeForcast',
        label: 'label.em.repair.repairPlanDetail.entity.rpdBeginTimeForcast',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'rpdBeginTimeActual',
        label: 'label.em.repair.repairPlanDetail.entity.rpdBeginTimeActual',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'rpdEndTimeForcast',
        label: 'label.em.repair.repairPlanDetail.entity.rpdEndTimeForcast',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'rpdEndTimeActual',
        label: 'label.em.repair.repairPlanDetail.entity.rpdEndTimeActual',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'rpdSpareCostPlan',
        label: 'label.em.repair.repairPlanDetail.entity.rpdSpareCostPlan',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rpdSpareCostActual',
        label: 'label.em.repair.repairPlanDetail.entity.rpdSpareCostActual',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rpdLaborCostPlan',
        label: 'label.em.repair.repairPlanDetail.entity.rpdLaborCostPlan',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rpdLaborCostActual',
        label: 'label.em.repair.repairPlanDetail.entity.rpdLaborCostActual',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rpdTotalCostPlan',
        label: 'label.em.repair.repairPlanDetail.entity.rpdTotalCostPlan',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rpdTotalCostActual',
        label: 'label.em.repair.repairPlanDetail.entity.rpdTotalCostActual',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'rpdRemark',
        label: 'label.em.repair.repairPlanDetail.entity.rpdRemark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {RepairPlanDetail, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
